module.exports = __webpack_public_path__ + "img/score_1.9dcab8cf.png";